import { render, staticRenderFns } from "./TrackerPermissionsModal.vue?vue&type=template&id=41c76650&scoped=true&"
import script from "./TrackerPermissionsModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./TrackerPermissionsModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c76650",
  null
  
)

export default component.exports